/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventTaskConfigDurationMinutesOverride } from './eventTaskConfigDurationMinutesOverride';
import type { EventTaskConfigCapacityOverride } from './eventTaskConfigCapacityOverride';
import type { EventTaskConfigRecordingConsentText } from './eventTaskConfigRecordingConsentText';
import type { EventTaskConfigUnlockConditions } from './eventTaskConfigUnlockConditions';
import type { EventTaskConfigLocked } from './eventTaskConfigLocked';

/**
 * Configuration for event tasks
 */
export interface EventTaskConfig {
  /** ID of the EventKind template to use */
  eventKindId: string;
  /** Force dedicated slots even for shared EventKinds */
  requireDedicatedSlots?: boolean;
  /** Optional task-specific duration override. If omitted, inherit from EventKind. */
  durationMinutesOverride?: EventTaskConfigDurationMinutesOverride;
  /** Optional task-specific capacity override. If omitted, inherit from EventKind. */
  capacityOverride?: EventTaskConfigCapacityOverride;
  /** Whether sessions should be recorded */
  requiresRecording?: boolean;
  /** Custom recording consent text */
  recordingConsentText?: EventTaskConfigRecordingConsentText;
  unlockConditions?: EventTaskConfigUnlockConditions;
  /** Whether the task is locked based on unlock conditions */
  locked?: EventTaskConfigLocked;
}
